export const F = {
  accountsReceivable: {
    payableFiltersInStore: 'accountsReceivable.payableFiltersInStore',
    payableBrandColumnInStore: 'accountsReceivable.payableBrandColumnInStore',
  },
  home: {
    brand: 'home.brand',
  },
  menu: {
    home: 'menu.home',
    rachel: 'menu.rachel',
    connections: 'menu.connections',
    showroom: 'menu.showroom',
    catalogs: 'menu.catalogs',
    orders: 'menu.orders',
    storeOrders: 'menu.storeOrders',
    customers: 'menu.customers',
    salesOpportunities: 'menu.salesOpportunities',
    targets: 'menu.targets',
    reports: 'menu.reports',
    analytics: 'menu.analytics',
    cases: 'menu.cases',
    invoices: 'menu.invoices',
    locals: 'menu.locals',
    accountsReceivable: {
      receivable: 'menu.accountsReceivable.receivable',
      payable: 'menu.accountsReceivable.payable',
    },
    settings: 'menu.settings',
    profile: 'menu.profile',
    storefront: 'menu.storefront',
    teams: 'menu.teams',
    adminTeceo: 'menu.adminTeceo',
    logout: 'menu.logout',
  },
  targets: {
    viewAll: 'targets.viewAll',
    createCustomerTargets: 'targets.createCustomerTargets',
    createSalesRepresentativeTargets: 'targets.createSalesRepresentativeTargets',
    createStoreTargets: 'targets.createStoreTargets',
    editItems: 'targets.editItems',
    viewOrderTargets: 'targets.viewOrderTargets',
    method: 'targets.method',
  },
} as const;

export type DeepValues<T> = T extends string
  ? T
  : T extends object
    ? DeepValues<T[keyof T]>
    : never;

export type FeatureKey = DeepValues<typeof F>;

export type AccountsReceivableFeatureKey = DeepValues<typeof F.accountsReceivable>;

export type HomeFeatureKey = DeepValues<typeof F.home>;

export type MenuFeatureKey = DeepValues<typeof F.menu>;

export type TargetsFeatureKey = DeepValues<typeof F.targets>;
